import React from 'react'
import { useState, useEffect  , useRef} from 'react';
import Select, { components } from 'react-select';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import axios from 'axios'
import ToastNotification from '../../../components/ToastNotification';
import { Modal, Button, Table, Form } from "react-bootstrap";
import { CiEdit } from "react-icons/ci";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { FaDownload } from "react-icons/fa6";
import logo from '../../../assets/star.jpg';
import { MdDeleteForever } from "react-icons/md";
import { useLoading } from '../../../context/LoadingContext';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';

import jsPDF from "jspdf";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "jspdf-autotable"; // <-- this is necessary

import autoTable from "jspdf-autotable";

const SaleReturn = ({ adminData, branchID ,companyID , financialYear }) => {
   const searchInputRef = useRef(null);

  const location = useLocation();
    const mode = location.state?.mode;
    const partyId = location.state?.partyId;
    const editData = location.state?.data;

  const [showForm, setShowForm] = useState(false);
  const { setLoading } = useLoading();
  
       const [offset, setOffset] = useState(0);
            const limit = 20;
            const [hasMore, setHasMore] = useState(true);
            const [fromDate, setFromDate] = useState();
            const [toDate, setToDate] = useState();
            const [isLocked, setIsLocked] = useState(false);
            const [fy, setFy] = useState([]);
                const [validUpto, setValidUpto] = useState(null);


            const [financialRange, setFinancialRange] = useState({
                from_date: '',
                to_date: ''
            });

  const handleAddClick = () => {
    setShowForm(true);
  }

       const getTodayDateTime = () => {
        const now = new Date();
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
        return now.toISOString().slice(0, 16);
    }; 
  const [formItems, setFormItems] = useState({
    party: '',
    cust_enq: '',
    quotation_date:getTodayDateTime(),
    sale_person: '',
    technician: '',
    grand_total: '',
    total_gst: "",
    sub_total: "",
      remark: 'By using this service, you agree to the terms and conditions.',
    description: '',
    ref_doc: '',
    type_acc: 'sale_invoice',
    customLetter: '',
    subject: '',
    customLetterHTML: '',

    party_add: '',
    ref_doc_sq: '',
    invoice_no: '',
    invoice_date: '',

    ref_doc_call: '',
    complaintId: '',
    ref_doc_challan: '',
    delivery:'',
  })


  const [formData, setFormData] = useState([]);

  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };


  const [search, setSearch] = useState("");

  const [showPartyModal, setShowPartyModal] = useState(false);
  const [showItemModal, setShowItemModal] = useState(false);
  const [items, setItems] = useState([]);
  const [selectedItemId, setSelectedItemId] = useState("");
  const [partyOptions, setPartyOptions] = useState([]);
  const [detail, setDetail] = useState([]);
  const [user, setUser] = useState([]);

  const [subTotal, setSubTotal] = useState(0);
  const [totalTax, setTotalTax] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [selectedParty, setSelectedParty] = useState("");
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [quotation, setQuotation] = useState([]);
  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [selectedPrint, setSelectedPrint] = useState({});
  const [showLetterModal, setShowLetterModal] = useState(false);

  const [selectedQuotation, setSelectedQuotation] = useState(null);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [fetchSale, setFetchSale] = useState([]);
  const [refDocs, setRefDocs] = useState([]);
  const [allRefDocs, setAllRefDocs] = useState([]);
  const [chargeMaster, setChargeMaster] = useState([]);
  const [chargeOptions, setChargeOptions] = useState([]);
  const [fetchReturn, setFetchReturn] = useState([]);
  const [branchDetail, setBranchDetail] = useState([])
  const [saleReturnRefDocs, setSaleReturnRefDocs] = useState([]);
  const [allSaleInvoices, setAllSaleInvoices] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
     const [useDefaultShipping, setUseDefaultShipping] = useState(true);
      const[company,setCompany] = useState([]);
  const [payableAmount, setPayableAmount] = useState(0);

             const [cgst, setCgst] = useState(0);
             const [sgst, setSgst] = useState(0);
             const [igst, setIgst] = useState(0);
             const [roundOff, setRoundOff] = useState(0);
             const [billDiscountPercent, setBillDiscountPercent] = useState(0);
             const [billDiscountAmount, setBillDiscountAmount] = useState(0);
             const [afterBillDiscountAmount, setAfterBillDiscountAmount] = useState(0);
             const [billDiscountType, setBillDiscountType] = useState("percent");
             const [billDiscountValue, setBillDiscountValue] = useState(0);
             const [extraChargesTotal, setExtraChargesTotal] = useState(0);
             const [totalDiscount, setTotalDiscount] = useState("0.00");

      useEffect(() => {
        if (showPartyModal) {
          setTimeout(() => {
            searchInputRef.current?.focus();
          }, 100);
        }
      }, [showPartyModal]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormItems(prev => ({
      ...prev,
      [name]: value
    }));


  };

  const [files, setFiles] = useState({
    file: null,

  })



  
        useEffect(() => {
            if (mode === "edit" && editData) {
                handleEdit(editData);   
            }
        }, [editData, mode]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024); // Convert bytes → MB
      if (fileSizeInMB > 2) {
        setToast("File size is too large! Please upload a file smaller than 2MB.", 'danger')
        return;
      }
      setFiles(prevFiles => ({ ...prevFiles, [e.target.name]: file }));
    }
  };

  const handleSelectChange = (e) => {
    const id = e.target.value;
    if (!id) return;

    const selectedItem = items.find((i) => i.id == id);
    if (!selectedItem) return;
    setFormData((prev) => [
      ...prev,
      {
        id: selectedItem.id,
        name: selectedItem.name,
        qty: 0,
        rate: selectedItem.rate || 0,
        amount: "",
        tax: 0,
        hsn: selectedItem.hsn || 0,

      },
    ]);
  };
  const filtered = partyOptions.filter(
    (p) =>
      p.label.toLowerCase().includes(search.toLowerCase()) ||
      (p.phone && p.phone.toLowerCase().includes(search.toLowerCase())) ||
      (p.address && p.address.toLowerCase().includes(search.toLowerCase()))
  );


  const handleGstChange = (value, index) => {
    const updated = [...formData];

    // Update tax
    updated[index].tax = value;

    // Convert tax string like "18%" to number 18
    const taxPercent = parseFloat(value) || 0;

    // Recalculate amounts
    const qty = parseFloat(updated[index].qty) || 0;
    const rate = parseFloat(updated[index].rate) || 0;

    const baseAmount = qty * rate;
    const gstAmount = parseFloat(((baseAmount * taxPercent) / 100).toFixed(2));
    const amount = parseFloat((baseAmount + gstAmount).toFixed(2));


    updated[index].baseAmount = baseAmount;
    updated[index].taxAmount = gstAmount;
    updated[index].amount = amount;

    // Update state
    setFormData(updated);

    // Recalculate totals for the table (including extra rows if any)
    recalcTotals(updated, formItems?.additionalDetails || []);
  };


  const handleFormItemChange = (index, field, value) => {
    const updatedItems = [...formData];

    updatedItems[index][field] = value;

    const qty = parseFloat(updatedItems[index].qty) || 0;
    const rate = parseFloat(updatedItems[index].rate) || 0;
    const taxPercent = parseFloat(updatedItems[index].tax) || 0;
    const discountPercent = parseFloat(updatedItems[index].discount) || 0;



    // Before discount
    const baseAmount = qty * rate;

    // Discount calculation
    const discountAmount = parseFloat(
      ((baseAmount * discountPercent) / 100).toFixed(2)
    );

    // After discount
    const discountedAmount = baseAmount - discountAmount;

    // GST calculation after discount
    const taxAmount = parseFloat(
      ((discountedAmount * taxPercent) / 100).toFixed(2)
    );

    // Final amount
    const totalAmount = parseFloat(
      (discountedAmount + taxAmount).toFixed(2)
    );

    updatedItems[index].baseAmount = baseAmount;
    updatedItems[index].discountAmount = discountAmount;
    updatedItems[index].discountedAmount = discountedAmount;
    updatedItems[index].taxAmount = taxAmount;
    updatedItems[index].amount = totalAmount;

    setFormData(updatedItems);

    recalcTotals(
      updatedItems,
      formItems?.additionalDetails || [],
      billDiscountValue,
      billDiscountType
    );
  };




  const updateRowField = (id, field, value) => {
    setFormItems(prev => {
      const updated = (prev.additionalDetails || []).map(row => {
        if (row.id === id) {
          const newRow = { ...row, [field]: value };

          // Recalculate value2 if value1 changes
          if (field === "value1") {
            const numeric = parseFloat(value) || 0;

            // Use current subTotal to calculate value2
            newRow.value2 = ((numeric * (formData.reduce((sum, item) => sum + (item.baseAmount || 0), 0))) / 100).toFixed(2);
          }

          return newRow;
        }
        return row;
      });

      const newFormItems = { ...prev, additionalDetails: updated };


      recalcTotals(formData, updated, billDiscountValue, billDiscountType);

      return newFormItems;
    });
  };

  const addRow = () => {
    setFormItems(prev => ({
      ...prev,
      additionalDetails: [
        ...(prev.additionalDetails || []),
        { id: Date.now(), type: "SGT" }
      ]
    }));
  };
 const deleteRow = (indexToRemove) => {
    const newExtra = (formItems.additionalDetails || []).filter(
      (_, idx) => idx !== indexToRemove
    );
    setFormItems((prev) => ({ ...prev, additionalDetails: newExtra }));
    recalcTotals(
      formData,
      newExtra,
      billDiscountValue,
      billDiscountType
    );
  };

    useEffect(() => {
          if (formData.length || formItems?.additionalDetails?.lengt) {
            recalcTotals(
              formData,
              formItems?.additionalDetails || [],
              billDiscountValue,
              billDiscountType
            );
          }
        }, [formData, formItems?.additionalDetails, billDiscountValue, billDiscountType]);

  const handleDeleteItem = (indexToRemove) => {
    const newItems = formData.filter((_, idx) => idx !== indexToRemove);
    const currentExtra = formItems.additionalDetails || [];

    recalcTotals(
      newItems,
      currentExtra,
      billDiscountValue,
      billDiscountType
    );

    setFormData(newItems);
  };


 const companyState = (company?.state || "").trim().toLowerCase();
  const partyState = (selectedParty?.state || "").trim().toLowerCase();
  const isInterState = companyState !== partyState;


  const recalcTotals = (
    items = [],
    extraRows = [],
    billDiscountValue = billDiscountPercent,
    discountType = billDiscountType
  ) => {

    const updatedItems = Array.isArray(items) ? items : [];
    const updatedExtra = Array.isArray(extraRows) ? extraRows : [];

    // 1. Total Item Amount
    const subTotal = updatedItems.reduce((sum, item) => {
      return sum + (Number(item.baseAmount) || 0);
    }, 0);

    // 2. Item Discount
    const totalDiscount = updatedItems.reduce((sum, item) => {
      return sum + (Number(item.discountAmount) || 0);
    }, 0);

    const itemNetAmount = subTotal - totalDiscount;

    // 3. Bill Discount
    let billDiscountAmount = 0;

    if (discountType === "percent") {
      billDiscountAmount =
        (itemNetAmount * Number(billDiscountValue || 0)) / 100;
    } else {
      billDiscountAmount = Number(billDiscountValue || 0);

      if (billDiscountAmount > itemNetAmount) {
        billDiscountAmount = itemNetAmount;
      }
    }

    // 4. Amount after all discounts
    const discountedAmount = itemNetAmount - billDiscountAmount;

    let totalExtraCharges = 0;
    let totalExtraGST = 0;

    updatedExtra.forEach((row) => {

      let chargeAmount = Number(row.value2) || 0;

      if (row.chargeType === "percent") {
        chargeAmount =
          (discountedAmount * chargeAmount) / 100;
      }

      totalExtraCharges += chargeAmount;

      const gstPercent = Number(row.gst) || 0;

      const gstAmount =
        (chargeAmount * gstPercent) / 100;

      totalExtraGST += gstAmount;

    });

    setExtraChargesTotal(totalExtraCharges.toFixed(2));

    let totalGST = 0;

    updatedItems.forEach((item) => {

      const itemAmount =
        Number(item.discountedAmount ?? item.baseAmount) || 0;

      const ratio =
        itemNetAmount > 0
          ? itemAmount / itemNetAmount
          : 0;

      const taxableItemAmount =
        discountedAmount * ratio;

      const gstPercent =
        Number(item.tax) || 0;

      const gst =
        (taxableItemAmount * gstPercent) / 100;

      totalGST += gst;

    });


    let cgst = 0;
    let sgst = 0;
    let igst = 0;

    const finalGST = totalGST + totalExtraGST;

    if (isInterState) {

      igst = finalGST;

    } else {

      cgst = finalGST / 2;
      sgst = finalGST / 2;

    }


    const grandTotal =
      discountedAmount +
      totalExtraCharges +
      totalExtraGST +
      totalGST;

    // const roundOff =
    //     Math.round(grandTotal) - grandTotal;


    setSubTotal(subTotal.toFixed(2));

    setTotalDiscount(totalDiscount.toFixed(2));

    setBillDiscountAmount(billDiscountAmount.toFixed(2));

    setAfterBillDiscountAmount(discountedAmount.toFixed(2));

    setPayableAmount(
      discountedAmount.toFixed(2)
    );

    setCgst(cgst.toFixed(2));
    setSgst(sgst.toFixed(2));
    setIgst(igst.toFixed(2));


    setTotalTax(finalGST.toFixed(2));

    // setGrandTotal(grandTotal.toFixed(2));

    // setRoundOff(roundOff.toFixed(2));

    const roundedGrandTotal = Math.round(grandTotal);

    const roundOff = roundedGrandTotal - grandTotal;

    setGrandTotal(roundedGrandTotal.toFixed(2));
    setRoundOff(roundOff.toFixed(2));

  };



  const handleSelectDoc = (selectedOption) => {
  if (!selectedOption) {
    setFormItems(prev => ({ ...prev, ref_doc: null }));
    return;
  }

  const selectedInvoice = allSaleInvoices.find(inv =>
    String(inv.id) === String(selectedOption.value)
  );

  if (!selectedInvoice) {
    console.warn("Invoice not found for:", selectedOption.value);
    return;
  }


  const additionalDetails = selectedInvoice.additional_charges
    ? JSON.parse(selectedInvoice.additional_charges).map(c => ({
        ...c,
        value2: Number(c.value2) || 0
      }))
    : [];

  // --- parse items ---
  let itemsData = [];
  try {
    itemsData = JSON.parse(selectedInvoice.items || "[]").map(item => {
      const qty = Number(item.qty) || 0;
      const rate = Number(item.rate) || 0;
      const tax = Number(item.tax) || 0;
      const baseAmount = qty * rate;
      const taxAmount = +((baseAmount * tax) / 100).toFixed(2);
      const amount = +(baseAmount + taxAmount).toFixed(2);
      return { ...item, qty, rate, tax, baseAmount, taxAmount, amount };
    });
  } catch (err) {
    console.error("Error parsing items JSON:", err);
  }

  const subTotal = itemsData.reduce((s, i) => s + i.baseAmount, 0);
  const totalGst = itemsData.reduce((s, i) => s + i.taxAmount, 0);
  const chargesTotal = additionalDetails.reduce(
    (sum, c) =>
      c.type?.toLowerCase() === "discount"
        ? sum - c.value2
        : sum + c.value2,
    0
  );
  const grandTotal = subTotal + totalGst + chargesTotal;

  setFormItems(prev => ({
    ...prev,
    ref_doc: selectedInvoice.id,
    // party: selectedInvoice.party,
    // partyName: selectedInvoice.party_name,
    cust_enq: selectedInvoice.cust_enq,
    quotation_date: selectedInvoice.quotation_date,
    sale_person: selectedInvoice.sale_person,
    technician: selectedInvoice.technician,
    description: selectedInvoice.description,
    remark: selectedInvoice.remark,
    file: selectedInvoice.file,
    delivery:
  selectedInvoice.delivery &&
  selectedInvoice.delivery !== "undefined"
    ? selectedInvoice.delivery
    : "",
    invoice_no: selectedInvoice.invoice_no,
  invoice_date: selectedInvoice.invoice_date,

  bill: selectedInvoice.bill || "",
    additionalDetails,
    grandTotal
  }));

  setFormData(itemsData);
 setBillDiscountType(selectedInvoice.bill_discount_type || "percent");
setBillDiscountValue(Number(selectedInvoice.bill_discount_value || 0));
setBillDiscountAmount(Number(selectedInvoice.bill_discount_amount || 0));
setPayableAmount(Number(selectedInvoice.taxable_amount || 0));
setSubTotal(Number(selectedInvoice.sub_total || 0));
setTotalTax(Number(selectedInvoice.total_gst || 0));
setCgst(Number(selectedInvoice.cgst || 0));
setSgst(Number(selectedInvoice.sgst || 0));
setIgst(Number(selectedInvoice.igst || 0));
setRoundOff(Number(selectedInvoice.round_off || 0));
setGrandTotal(Number(selectedInvoice.grand_total || 0));
};




useEffect(() => {
  if (!formItems.party) {
    setRefDocs([]);
    setFormItems(prev => ({ ...prev, ref_doc: null }));
    return;
  }

  const filteredDocs = fetchSale
    .filter(p => String(p.party) === String(formItems.party))
    .filter(p => {
  const id = p.id;

  return (
    !fetchReturn.some(
      r => String(r.ref_doc) === String(id)
    ) ||
    String(id) === String(formItems.ref_doc)
  );
})
    .map(p => {
      const id = p.id;
      return {
        value: String(id),
        label: `SL/${p.inv_no || id}/${p.branchId}`
      };
    });

  setRefDocs(filteredDocs);
}, [formItems.party, fetchSale, fetchReturn, formItems.ref_doc]);




  const fecthDetail = async () => {
    setLoading(true)
    try {
      const resInventory = await axios.get('https://api.skyguard.group/api/fetch-inventory');
      const items = resInventory.data.result || [];
      setItems(items);


    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };

  const fetchPartyDetail = async () => {
    setLoading(true)
    try {
      const resParty = await axios.get("https://api.skyguard.group/api/fetch-party-bill");

      // transform result into { value, label }
      const options = resParty.data.map((p) => ({
        value: p.id,
        label: p.name,
        phone: p.phone,
        address: p.address,
           state: p.state

      }));

      const data = resParty.data;

      setDetail(data);

      setPartyOptions(options);

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const fectEmphDetail = async () => {
    setLoading(true)
    try {
      const resEmployee = await axios.get('https://api.skyguard.group/api/fetch-employee');
        const filtered = (resEmployee.data.result || []).filter(
      emp => emp.emp_id !== null && emp.emp_id !== undefined && emp.emp_id !== ""
    );

    setUser(filtered);


    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };

  const fetchSaleQuotation = async () => {
    setLoading(true)
    try {
      const response = await axios.get('https://api.skyguard.group/api/fetch-sale-quotation');
      setQuotation(response.data);
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };


const fetchSaleReturn = async (fromDate,
        toDate,
        branchCode,
        newOffset = 0) => {

      if (!branchCode) {
            console.log("Branch code missing");
            return;
        }
  try {
    const response = await axios.get(
      'https://api.skyguard.group/api/fetch-sale-return',
      {
                    params: {
                        from_date: fromDate,
                        to_date: toDate,
                        branch_code: branchCode,
                        limit: limit,
                        offset: newOffset
                    }
                }
    );

    const saleReturnOnly = response.data.filter(
      item => item.type_acc === "sale_return"
    );

    const returnRefDocs = saleReturnOnly
      .map(item => String(item.ref_doc))
      .filter(Boolean); 

    setSaleReturnRefDocs(returnRefDocs);
     const result = saleReturnOnly;
            if (newOffset === 0) {
                setFetchReturn(result);
                setHasMore(true);
            }

            else {
                setFetchReturn(prev => {
                    const merged = [...prev, ...result];
                    const unique = Array.from(
                        new Map(merged.map(item => [item.id, item])).values()
                    );

                    return unique;
                });
            }

            // check if more data exists
            if (result.length < limit) {
                setHasMore(false);
            }
  } catch (error) {
    console.log(error);
  }
};

  const fetchChargeDetail = async () => {
    setLoading(true)
    try {
      const response = await axios.get('https://api.skyguard.group/api/fetch-master-charge');
      setChargeMaster(response.data);



      const options = response.data.map((item) => ({
        value: item.charge_name,
        label: item.charge_name
      }));

      setChargeOptions(options);

    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };

  const fetchSaleInvoice = async () => {
    setLoading(true)
    try {
      const response = await axios.get(
        'https://api.skyguard.group/api/fetch-sale-invoice'
      );

      const saleInvoices = response.data.filter(
        item => item.type_acc === "sale_invoice"
      );

      const filteredInvoices = saleInvoices.filter(
        inv => !saleReturnRefDocs.includes(inv.id)
     
      );   
      setAllSaleInvoices(saleInvoices);
      setFetchSale(filteredInvoices);

setRefDocs(
  filteredInvoices.map(q => ({
    value: q.id,
    label: q.inv_no
      ? `SL: ${q.inv_no}`
      : `SL: ${q.ref_doc}`,
    ref_doc: q.ref_doc
  }))
);

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };



  const fetchCompany = async () => {
      setLoading(true)
    try {
      const res = await axios.get(`https://api.skyguard.group/api/fetch-company-localData/${companyID}`);
      setCompany(res.data);
    } catch (error) {
      console.log(error)
    } finally {
     setLoading(false);
        }
  };


  useEffect(() => {
    // fetchSaleReturn();
    fetchCompany();
  }, []);

  useEffect(() => {
    if (saleReturnRefDocs.length >= 0) {
      fetchSaleInvoice();
    }
  }, [saleReturnRefDocs]);



 const fetchBranchDetail = async () => {
        setLoading(true)
        try {
            const branchRes = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
            setBranchDetail(branchRes.data)
            return branchRes.data.code;
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };


  const fetchYearDetail = async () => {
                    setLoading(true);
                    try {
                        const branchCode = await fetchBranchDetail();
                        const res = await axios.get(
                            `https://api.skyguard.group/api/fetch-financial-year-localData/${financialYear}`
                        );
                        const yearData = res.data;
                        setFy(yearData);
                        // setIsLocked(yearData.is_locked === 1);

                                  setValidUpto(yearData.valid_up_to);
                let shouldLock = false;

        // First check is_locked
        if (Number(yearData.is_locked) === 1) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const validUptoDate = new Date(yearData.valid_up_to);
            validUptoDate.setHours(0, 0, 0, 0);

            // Lock only if valid_up_to date has passed
            shouldLock = validUptoDate <= today;
        }

        setIsLocked(shouldLock);

                        setFinancialRange({
                            from_date: yearData.from_date,
                            to_date: yearData.to_date
                        });
            
                        await fetchSaleReturn(
                            yearData.from_date,
                            yearData.to_date,
                            branchCode,
            
                        );
                    } catch (error) {
                        console.log(error);
                    } finally {
                        setLoading(false);
                    }
                };


   const isVoucherLocked = (paymentDate) => {
    if (!validUpto || !paymentDate) return false;

    const voucherDate = new Date(paymentDate);
    voucherDate.setHours(0, 0, 0, 0);

    const fyValidUpto = new Date(validUpto);
    fyValidUpto.setHours(0, 0, 0, 0);

    return voucherDate <= fyValidUpto;
};             

  useEffect(() => {
    fecthDetail();
    fetchPartyDetail();
    fectEmphDetail();
    fetchSaleQuotation();
    fetchSaleInvoice();
    fetchChargeDetail();
  fetchYearDetail();
    fetchBranchDetail();
  }, []);


  const handleUpdate = async (e) => {
    e.preventDefault();

    const sendData = new FormData();
    const safe = (v) => (v === undefined || v === null ? "" : v);

    sendData.append("type_acc", "sale_return");
    sendData.append("cust_enq", formItems.cust_enq);
    sendData.append("quotation_date", formItems.quotation_date || new Date().toISOString().split("T")[0]);
    sendData.append("sale_person", formItems.sale_person);
    sendData.append("technician", formItems.technician);
    sendData.append("remark", safe(formItems.remark));
    sendData.append("description", safe(formItems.description));
    sendData.append("grand_total", grandTotal);
    sendData.append("total_gst", totalTax);
    sendData.append("sub_total", subTotal);
    sendData.append("customLetter", formItems.customLetter);
    sendData.append("subject", formItems.subject);
    sendData.append("party", safe(formItems.party));
    // sendData.append("items", JSON.stringify(formData));
    sendData.append("invoice_no", safe(formItems.invoice_no));
    sendData.append("invoice_date", safe(formItems.invoice_date));
      sendData.append("branchId", branchDetail.code);
        sendData.append('delivery',formItems.delivery);

         sendData.append("taxable_amount", payableAmount);
    sendData.append("cgst", cgst);
    sendData.append("sgst", sgst);
    sendData.append("igst", igst);
    sendData.append("round_off", roundOff);
    sendData.append("is_inter_state", isInterState ? 1 : 0);
    sendData.append("bill_discount_type", billDiscountType);
    sendData.append("bill_discount_value", billDiscountValue);
    sendData.append("bill_discount_amount", billDiscountAmount);
    sendData.append("discounted_taxable_amount", payableAmount);
    sendData.append("gst_amount", totalTax);
    sendData.append("extra_charges_total", extraChargesTotal);
      
    if (files.file) sendData.append("file", files.file);

sendData.append("ref_doc", formItems.ref_doc );

      const validItems = formData
      .filter(item => item.name && item.name.trim() !== "")
      .map(item => {

        const qty = Number(item.qty) || 0;
        const rate = Number(item.rate) || 0;
        const gstPercent = Number(item.tax) || 0;
        const discountPercent = Number(item.discount) || 0;
        const baseAmount = qty * rate;
        const discountAmount = Number(
          ((baseAmount * discountPercent) / 100).toFixed(2)
        );
        const taxableAmount = baseAmount - discountAmount;
        const gstAmount = Number(
          ((taxableAmount * gstPercent) / 100).toFixed(2)
        );
        const totalAmount = Number(
          (taxableAmount + gstAmount).toFixed(2)
        );


        return {
          id: item.id,
          name: item.name,
          qty,
          rate,
          baseAmount,
          tax: gstPercent,
          hsn: item.hsn || "",

          // discount details
          discount: discountPercent,
          discountAmount,
          taxableAmount,
          gstAmount,
          totalAmount,

    //        sr_no: Array.isArray(item.sr_no)
    // ? item.sr_no
    // : getSerialNumbers(item.id, qty)
        };
      });

    sendData.append("items", JSON.stringify(validItems));

    sendData.append(
      "additional_charges",
      JSON.stringify(
        (formItems.additionalDetails || []).map((row) => {

          let chargeAmount = Number(row.value2) || 0;

          if (row.chargeType === "percent") {
            chargeAmount =
              (Number(payableAmount) * chargeAmount) / 100;
          }
          const gstPercent = Number(row.gst) || 0;
          const gstAmount =(chargeAmount * gstPercent) / 100;

          return {
            id: row.id || null,
            type: row.type,
            charge_type: row.chargeType || "amount",
            value1: Number(row.value1) || 0,
            value2: Number(row.value2) || 0,
            charge_amount: Number(chargeAmount.toFixed(2)),
            gst: gstPercent,
            gst_amount: Number(gstAmount.toFixed(2)),
            taxable: false
          };

        })
      )
    );

for (const [key, value] of sendData.entries()) {
  console.log(`${key}:`, value);
}

    if (isEditMode && editingCompanyId) {
      sendData.append("edit_by", adminData.user.id);
    } else {
      sendData.append("added_by", adminData.user.id);
    }
   

    try {
      let res;

      if (isEditMode && editingCompanyId) {
        res = await axios.put(
          `https://api.skyguard.group/api/update-sale-return/${editingCompanyId}`,
          sendData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        fetchSaleReturn(financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            0);
        showToast("Sale Return Updated Successfully!", "success");
      } else {
        res = await axios.post(
          "https://api.skyguard.group/api/add-sale-return",
          sendData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        showToast("Sale Invoice Return Successfully!", "success");
      }

      fetchSaleReturn(financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            0);

      resetForm();

    } catch (err) {
      console.error("❌ Error:", err.response?.data || err.message);
      showToast("Failed!", "danger");
    }
  };

  const resetForm = () => {
    setFormItems({
      party: "",
      cust_enq: "",
      quotation_date:getTodayDateTime(),
      sale_person: "",
      technician: "",
      grand_total: "",
      total_gst: "",
      sub_total: "",
        remark: 'By using this service, you agree to the terms and conditions.',
      description: "",
      ref_doc: "",
      type_acc: "",
    });

    setFormData([]);
    setSelectedDoc(null);
    setSelectedParty(null);
    setSubTotal("0.00");
    setTotalTax("0.00");
    setGrandTotal("0.00");
    setFiles({});
    setShowForm(false);
  };

  const handleEdit = async (form) => {
   const locked = isVoucherLocked(form.quotation_date);
     setIsLocked(locked);

    setIsEditMode(true);

    let parsedItems = [];
    try {
      parsedItems = JSON.parse(form.items || "[]");
    } catch (err) {
      console.log("Invalid JSON for items:", err);
    }


  parsedItems = parsedItems.map((item) => {
      const qty = parseFloat(item.qty) || 0;
      const rate = parseFloat(item.rate) || 0;
      const tax = parseFloat(item.tax) || 0;

      const baseAmount = qty * rate;
      const taxAmount = parseFloat(((baseAmount * tax) / 100).toFixed(2));
      const totalAmount = parseFloat((baseAmount + taxAmount).toFixed(2));

      return {
        ...item,
        sr_no: Array.isArray(item.sr_no)
      ? item.sr_no
      : item.sr_no
      ? [item.sr_no]
      : [],
        baseAmount,
        taxAmount,
        amount: totalAmount,
      };
    });

    setFormData(parsedItems);


    let parsedAdditionalDetails = [];
    try {
      parsedAdditionalDetails = JSON.parse(form.additional_charges || "[]");
    } catch (err) {
      console.log("Invalid JSON for additional_charges:", err);
    }

      setBillDiscountType(form.bill_discount_type || "percent");
    setBillDiscountValue(form.bill_discount_value || 0);
    setBillDiscountAmount(Number(form.bill_discount_amount || 0).toFixed(2));

     recalcTotals(
      parsedItems,
      parsedAdditionalDetails,
      Number(form.bill_discount_value) || 0,
      form.bill_discount_type || "percent"
    );

   const subTotal = parsedItems.reduce((sum, item) => sum + (item.baseAmount || 0), 0);
      const totalGst = parsedItems.reduce((sum, item) => sum + (item.taxAmount || 0), 0);
      const chargesTotal = parsedAdditionalDetails.reduce((sum, item) => {
        const value = Number(item.value2) || 0;
        return item.type?.toLowerCase() === "discount" ? sum - value : sum + value;
      }, 0);
      const grandTotal = subTotal + totalGst + chargesTotal;



      setSubTotal(subTotal.toFixed(2));
      setTotalTax(totalGst.toFixed(2));
      setGrandTotal(grandTotal.toFixed(2));

    setFormItems({
      id: form.id || "",
      party: form.party || "",
      partyName: form.party_name || "",
      cust_enq: form.cust_enq || "",
      quotation_date: form.quotation_date || "",
      sale_person: form.sale_person || "",
      technician: form.technician || "",
      remark: form.remark || "",
      description: form.description || "",

      ref_doc:String(form.ref_doc),
      ref_doc_sq: form.ref_doc_sq || null,
      type_acc: form.type_acc || "",
      subject: form.subject || "",
      customLetter: form.customLetter || "",
      additionalDetails: parsedAdditionalDetails,
      delivery:form.delivery || "",
        inv_no: form.inv_no || "",              
  branchId: form.branchId || "",

      id: form.id,
      type: form.type || "",
      chargeType:
        form.chargeType ||
        form.charge_type ||
        "amount",
      value1: Number(form.value1) || 0,
      value2: Number(form.value2) || 0,
      gst: Number(form.gst) || 0,
      charge_amount: Number(form.charge_amount) || 0,
      gst_amount: Number(form.gst_amount) || 0,
      taxable: form.taxable ?? false
    });


    setFiles({ file: form.file || null });
    setEditingCompanyId(form.id);
    setShowForm(true);
  };


  const handleViewLetter = (quotation) => {
    setSelectedQuotation(quotation);
    setShowLetterModal(true);
  };


  const formatDateTime = (datetime) => {
    if (!datetime) return "";
    const [date, time] = datetime.split(" ");
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year} ${time}`;
  };


  const filterReturn = fetchReturn.filter((tt) => {
    const term = searchTerm.toLowerCase();

    return (
      (tt.party_name && tt.party_name.toLowerCase().includes(term))

    );
  });


  const exportInvoiceToPDF = (selectedQuotation) => {
    const doc = new jsPDF("p", "mm", "a4");

    /* ================= HEADER ================= */
    doc.setFontSize(16);
    doc.setTextColor(0);
    doc.text("STAR SIGNATURE SERVICES", 105, 16, { align: "center" });

    doc.setFontSize(10);

    const addressText =
      "A-8 JAI ISH KRUPA CHS LTD. ANAND NAGAR OPP AL-NOOR MASZID VASAI W 401202 THANE MUMBAI MAHARASHTRA";

    const addressLines = doc.splitTextToSize(addressText, 180);
    doc.text(addressLines, 105, 22, { align: "center" });

    let currentY = 22 + addressLines.length * 5;

    doc.text(
      "BRANCH: DADAR | THANE | PUNE | AURANGABAD | GOA PANJIM",
      105,
      currentY,
      { align: "center" }
    );

    currentY += 6;

    const contactLines = doc.splitTextToSize(
      "Phone: 9209206677, 9209203355, 9324004632 | Email: starsignatureservices@gmail.com",
      180
    );
    doc.text(contactLines, 105, currentY, { align: "center" });

    currentY += contactLines.length * 5;

    doc.text("GSTIN: 27ADYPY53133M2ZH", 105, currentY + 2, {
      align: "center"
    });

    doc.setFontSize(12);
    doc.text("SALE Return", 105, currentY + 10, { align: "center" });

    /* ================= BILL TO / INVOICE ================= */
    autoTable(doc, {
      startY: currentY + 15,
      theme: "grid",
      styles: { fontSize: 9 },
      headStyles: {
        // fillColor: [255, 255, 255], // white header
        textColor: 0,
        fontStyle: "bold"
      },
      head: [["Bill To", "Invoice Details"]],
      body: [
        [
          `Party Name: ${selectedQuotation.party_name}
  Customer Enquiry: ${selectedQuotation.cust_enq || "-"}
  Contact: ${selectedQuotation.party_phone}
  Address: ${selectedQuotation.party_address}`,

          `Invoice No: ${selectedQuotation.invoice_no || "-"}
  Date: ${selectedQuotation.quotation_date}
  Sale Person: ${selectedQuotation.sale_emp_first} ${selectedQuotation.sale_emp_middle || ""} ${selectedQuotation.sale_emp_last}
  Technician: ${selectedQuotation.tech_emp_first || ""} ${selectedQuotation.tech_emp_middle || ""} ${selectedQuotation.tech_emp_last || ""}`
        ]
      ]
    });

    /* ================= ITEMS TABLE ================= */
    const items = selectedQuotation.items
      ? JSON.parse(selectedQuotation.items)
      : [];

    const itemRows = items.map((item, index) => [
      index + 1,
      item.name,
      item.qty,
      item.rate,
      item.tax,
      item.amount
    ]);

    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 8,
      theme: "grid",
      styles: { fontSize: 9 },
      headStyles: {
        // fillColor: [255, 255, 255], // 🔥 removes grey
        textColor: 0,
        fontStyle: "bold"
      },
      head: [["#", "Item Name", "Qty", "Rate", "GST %", "Amount"]],
      body: itemRows
    });

    /* ================= TOTALS ================= */
    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 5,
      theme: "grid",
      styles: { fontSize: 10 },
      body: [
        ["Total GST", selectedQuotation.total_gst],
        ["Sub Total", selectedQuotation.sub_total],
        ["Grand Total", selectedQuotation.grand_total]
      ],
      columnStyles: {
        0: { halign: "right", fontStyle: "bold" },
        1: { halign: "right" }
      }
    });

    /* ================= FOOTER ================= */
    let footerY = doc.lastAutoTable.finalY + 8;

    if (selectedQuotation.description) {
      doc.text(`Description: ${selectedQuotation.description}`, 14, footerY);
      footerY += 6;
    }

    if (selectedQuotation.remark) {
      doc.text(`Remark: ${selectedQuotation.remark}`, 14, footerY);
    }

    doc.save(`Invoice_${selectedQuotation.invoice_no || "NA"}.pdf`);
  };


const handlePrint = () => {
  const printContents = document.getElementById("invoice-print-area").innerHTML;
  const originalContents = document.body.innerHTML;

  // Open a new window for printing
  const printWindow = window.open("", "_blank", "width=900,height=600");
  printWindow.document.write(`
    <html>
      <head>
     
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          table { border-collapse: collapse; width: 100%; }
          table, th, td { border: 1px solid #000; }
          th, td { padding: 5px; text-align: center; }
          .text-start { text-align: left; }
        </style>
      </head>
      <body>
        ${printContents}
      </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
  printWindow.close();
};

 const handleLoadMore = () => {
        const nextOffset = offset + limit;
        setOffset(nextOffset);
        fetchSaleReturn(
            financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            nextOffset
        );
    };

  return (
    <>
      <div className='main-section'>
        <ToastNotification
          show={toast.show}
          message={toast.message}
          bg={toast.bg}
          onClose={() => setToast({ ...toast, show: false })}
        />
        <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
          <h3 className='my-3 fw-bold fs-5 golos'>Sale Return </h3>

          <div class="mb-3 row gx-3 gy-2 align-items-center  d-flex justify-content-between">
            <div class="col-12 col-md-4">
              <input
                type="text"
                class="form-control"
                id="searchInput"
                placeholder="Search by Item Name..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                
              />
            </div>
                 <div className="col-12 col-md-2 d-flex justify-content-end">
                                                                      <button
                                                                          className={`btn ${showForm ? 'btn-danger' : 'btn-success'}`}
                                                                          onClick={() => {
                                                                              setShowForm(prev => !prev);
                                          
                                                                              if (showForm) {
                                                                                  setIsEditMode(false);
                                                                                  setEditingCompanyId(null);
                                                                                  resetForm();
                                                                              }
                                                                          }}
                                                                      >
                                                                          {showForm ? (
                                                                              <>
                                                                                  Close <FaTimes size={18} />
                                                                              </>
                                                                          ) : (
                                                                              <>
                                                                                  Add <AiOutlinePlusCircle size={18} />
                                                                              </>
                                                                          )}
                                                                      </button>
                                                                  </div>
          </div>


          {showForm && (
          
             <fieldset >
                 <form onSubmit={handleUpdate}>


              <div className='card p-3 my-3 shadow-sm bg-white border'>
                <div className='row'>

                  <div className='col-12'>

                         {isEditMode && (
  <div className="mb-3">
    <label>Document No:</label> <br />
    <span className="badge bg-primary px-3 py-2">
      {`SR/${formItems.inv_no}/${formItems.branchId}`}
    </span>
  </div>
)}
                    <div className='row g-3'>

                      
                      <div className="col-12 col-md-4">
                        <label htmlFor="party" className="form-label fw-medium">Select Party</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Choose Party..."
                          value={formItems.partyName || ""}
                          readOnly
                          onClick={() => setShowPartyModal(true)}
                          required 
                              disabled={isEditMode && isLocked}
                        />

                        <Modal show={showPartyModal} onHide={() => setShowPartyModal(false)} size="lg">
                          <Modal.Header closeButton>
                            <Modal.Title>Search Party</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <Form.Control
                              type="text"
                              placeholder="Search by name, phone, or address"
                              value={search}
                              onChange={(e) => setSearch(e.target.value)}
                               ref={searchInputRef}
                            />
                            <div className="table-responsive mt-3">
                              <Table striped bordered hover className="mt-3">
                                <thead>
                                  <tr>
                                     <th>Action</th>
                                    <th>Name</th>
                                    <th>Phone</th>
                                    <th>Address</th>
                                   
                                  </tr>
                                </thead>
                                <tbody>
                                  {filtered.map((p) => (
                                    <tr key={p.value}>
                                       <td className="text-center" style={{ width: "80px" }}>
                                        <Button
                                          variant="primary"
                                          size="sm"
                                          onClick={() => {
                                               setSelectedParty(p);
                                            setFormItems((prev) => ({
                                              ...prev,
                                              party: p.value,
                                              partyName: p.label,
                                            }));
                                            setShowPartyModal(false);
                                          }}
                                        >
                                          Select
                                        </Button>
  

                                      </td>
                                      <td>{p.label}</td>
                                      <td>{p.phone}</td>
                                      <td style={{ maxWidth: "300px", whiteSpace: "normal", overflow: "hidden", textOverflow: "ellipsis" }}>
                                        {(p.address || "").length > 50 ? `${(p.address || "").slice(0, 50)}...` : (p.address || "NA")}
                                      </td>
                                     
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </div>

                          </Modal.Body>
                        </Modal>
                      </div>


                      <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Ref Doc.</label>
                        <Select
                          placeholder="Choose Ref Doc..."
                          options={refDocs}
                          value={
                            refDocs.find(
                              opt => String(opt.value) === String(formItems.ref_doc )
                            ) || null
                          }
                          onChange={handleSelectDoc}
                          isDisabled={isEditMode}
                            isDisabled={isEditMode && isLocked}
                               
                        /> 
                      </div>

                      <div className="col-12 col-sm-12 col-md-4">
                        <label className="form-label fw-medium">Sale Person</label>
                        <Select
                          options={user.map((t) => ({
                            value: t.id,
                            label: `${t.first} ${t.last} (${t.emp_id})`,
                          }))}

                          value={
                            user
                              .map((t) => ({
                                value: t.id,
                                label: `${t.first} ${t.last} (${t.emp_id})`,
                              }))
                              .find((opt) => opt.value == formItems.sale_person) || null
                          }
                          onChange={(e) =>
                            handleChange({ target: { name: "sale_person", value: e.value } })
                          }
                          className="w-100"
                          menuPlacement="auto"
                            isDisabled={isEditMode && isLocked}
                        />

                      </div>

                      <div className="col-12 col-sm-12 col-md-4">
                        <label className="form-label fw-medium">Technician</label>
                        <Select
                          options={user.map((t) => ({
                            value: t.id,
                            label: `${t.first} ${t.last} (${t.emp_id})`,
                          }))}

                          value={
                            user
                              .map((t) => ({
                                value: t.id,
                                label: `${t.first} ${t.last} (${t.emp_id})`,
                              }))
                              .find((opt) => opt.value == formItems.technician) || null
                          }
                          onChange={(e) =>
                            handleChange({ target: { name: "technician", value: e.value } })
                          }
                          className="w-100"
                          menuPlacement="auto"
                          isDisabled={isEditMode && isLocked}
                        />


                      </div>


                      <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Date</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          name="quotation_date"
                          value={formItems.quotation_date || new Date().toISOString().split("T")[0]}
                          onChange={handleChange}
                             disabled={isEditMode && isLocked}
                        />
                      </div>

                      <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Customer Reference No</label>
                        <input
                          type="text"
                          className="form-control"
                          name="cust_enq"
                          value={formItems.cust_enq}
                          onChange={handleChange}
                             disabled={isEditMode && isLocked}
                        />
                      </div>


                  <div className="col-12 col-md-4">
                    <div className="d-flex align-items-center gap-2 text-nowrap">
                      <label htmlFor="delivery" className="fw-medium mb-0">
                        Shipping Address
                      </label>
                      <input
                        type="checkbox"
                        className="form-check-input m-0"
                        id="editShipping"
                        checked={!useDefaultShipping}
                        onChange={() => setUseDefaultShipping(!useDefaultShipping)}
                            disabled={isEditMode && isLocked}
                      />

                      <span className="text-muted">Change Address</span>
                    </div>

                    <input
                      type="text"
                      className="form-control mt-1"
                      id="delivery"
                      name="delivery"
                      value={formItems.delivery || ""}
                      onChange={handleChange}
                      disabled={useDefaultShipping}
                           disabled={isEditMode && isLocked}
                    />
                  </div>

                      <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Items :</label>
                        <Select
                          options={items.map((t) => ({
                            value: t.id,
                            label: `${t.name} (${t.stock})`,
                          }))}

                          value={
                            selectedItemId
                              ? {
                                value: selectedItemId,
                                label:
                                  items.find((i) => i.id === selectedItemId)?.name +
                                  " (" +
                                  items.find((i) => i.id === selectedItemId)?.stock +
                                  ")",
                              }
                              : null
                          }

                          onChange={(e) =>
                            handleSelectChange({
                              target: { name: "emp_id", value: e?.value || "" },
                            })
                          }

                          className="w-100"
                          menuPlacement="auto"
                          isDisabled={isEditMode && isLocked}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 mt-3">
                    {/* <div className="table-responsive">
                      <table className="table table-bordered text-center align-middle">
                        <thead className="table-primary">
                          <tr>
                            <th>Item Name</th>
                            <th>Quantity</th>
                            <th> Sale Rate</th>
                            <th>Item GST</th>
                            <th>Amount</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {formData.length === 0 ? (
                            <tr>
                              <td colSpan="6" className="text-center text-muted">
                                Select an item from the dropdown to add here
                              </td>
                            </tr>
                          ) : (
                            formData.map((fi, idx) => (
                              <tr key={idx}>
                                <td><input type="text" className="form-control" value={fi.name} onChange={(e) => handleFormItemChange(idx, "name", e.target.value)}       disabled={isEditMode && isLocked}/></td>
                                <td><input type="number" className="form-control" value={fi.qty} onChange={(e) => handleFormItemChange(idx, "qty", e.target.value)}      disabled={isEditMode && isLocked} /></td>
                                <td><input type="number" className="form-control" value={fi.rate} onChange={(e) => handleFormItemChange(idx, "rate", e.target.value)}      disabled={isEditMode && isLocked} /></td>

                              
                                <td>
                                  <select
                                    className="form-control"
                                    value={fi.tax}
                                    onChange={(e) => handleGstChange(e.target.value, idx)}
                                      disabled={isEditMode && isLocked}
                                  >

                                    <option value={fi.tax}> {fi.tax} </option>


                                    <option disabled>──────────</option>


                                    <option value="0%">0%</option>
                                    <option value="5%">5%</option>
                                    <option value="12%">12%</option>
                                    <option value="18%">18%</option>
                                    <option value="28%">28%</option>
                                  </select>
                                </td>
 
                                <td><input type="text" className="form-control" value={fi.amount || ""} readOnly   disabled={isEditMode && isLocked}/></td>
                                <td>
                                  <button className="btn btn-danger" onClick={() => handleDeleteItem(idx)}  disabled={isEditMode && isLocked}>Delete</button>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td colSpan="3" className="text-end fw-bold">Total GST</td>
                            <td><input type="text" value={totalTax} readOnly className="form-control" /></td>
                            <td className="text-end fw-bold">SUB Total</td>




                            <td><input type="text" value={subTotal} readOnly className="form-control" /></td>
                          </tr>
                          <tr className="text-end fw-bold">
                            <td colSpan="6">
                              <div className="d-flex justify-content-end mb-2">
                                <button
                                  type="button"
                                  className="btn btn-primary btn-sm"
                                  onClick={addRow}
                                   disabled={isEditMode && isLocked}
                                >
                                  + Add Row
                                </button>
                              </div>
                            </td>
                          </tr>

                          {formItems.additionalDetails?.map((row, index) => (
                            <tr key={row.id || index}>
                              <td colSpan="6">
                                <div className="d-flex justify-content-end align-items-center gap-2">
                                  <Select
                                    options={chargeOptions}
                                    value={chargeOptions.find(option => option.value === row.type)}
                                    onChange={(selected) => {

                                      const selectedCharge = chargeMaster.find(
                                        (item) => item.charge_name === selected.value
                                      );
                                      updateRowField(row.id, "type", selected.value);


                                      if (selectedCharge) {
                                        updateRowField(row.id, "value1", selectedCharge.charge_mrp);
                                      }
                                    }}
                                    placeholder="Select Charge"
                                    hideSelectedOptions={false}
                                    
                                      menuPortalTarget={document.body}
                                styles={{
                                  container: base => ({ ...base, width: 150 }),
                                  menuPortal: base => ({ ...base, zIndex: 9999 })
                                }}
                                isDisabled={isEditMode && isLocked}
                                  />


                                  <input
                                    type="text"
                                    className="form-control"
                                    style={{ width: "120px" }}
                                    value={row.value1 || ""}
                        
                                    onChange={(e) => updateRowField(row.id, "value1", e.target.value)}
                                     disabled={isEditMode && isLocked}
                                  />

                                  <input
                                    type="text"
                                    className="form-control"
                                    style={{ width: "120px" }}
                                    value={row.value2 || ""}
                                  
                                    onChange={(e) => updateRowField(row.id, "value2", e.target.value)}
                                     disabled={isEditMode && isLocked}
                                  />

                                
                                  <button className="btn btn-danger btn-sm" onClick={() => deleteRow(index)}  disabled={isEditMode && isLocked}>

                                    <MdDeleteForever size={20} />
                                  </button>
                                </div>
                              </td>
                            </tr>

                          ))}
                          <tr>
                            <td colSpan="5" className="text-end fw-bold">Grand Total </td>
                            <td><input type="text" value={grandTotal} readOnly className="form-control" /></td>
                          </tr>
                        </tfoot>
                      </table>
                    </div> */}
                        <div className="table-responsive">
                                          <table className="table table-bordered text-center align-middle">
                                            <thead className="table-primary">
                                              <tr>
                                                <th>Item Name</th>
                                                <th>Quantity</th>
                                                <th>Sale Rate</th>
                                        
                                                <th>Item GST</th>
                                                <th>Amount</th>
                                                <th>Action</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {formData.length === 0 ? (
                                                <tr>
                                                  <td colSpan="6" className="text-center text-muted">
                                                    Select an item from the dropdown to add here
                                                  </td>
                                                </tr>
                                              ) : (
                                                formData.map((fi, idx) => (
                                                  <tr key={idx}>
                    
                                                    <td><input type="text" className="form-control" value={fi.name} onChange={(e) => handleFormItemChange(idx, "name", e.target.value)} disabled={isEditMode && isLocked}/></td>
                                                    <td><input type="number" className="form-control" value={fi.qty} onChange={(e) => handleFormItemChange(idx, "qty", e.target.value)} disabled={isEditMode && isLocked}/></td>
                                                    <td><input type="number" className="form-control" value={fi.rate} onChange={(e) => handleFormItemChange(idx, "rate", e.target.value)} disabled={isEditMode && isLocked} /></td>
                    
                                               
                    
                                                     <td>
                                                                          <select
                                                                            className="form-control"
                                                                            value={fi.tax}
                                                                            onChange={(e) => handleGstChange(+e.target.value, idx)}
                                                                            disabled={isEditMode && isLocked}
                                                                          >
                                                                            <option value={0}>0%</option>
                                                                            <option value={0.25}>0.25%</option>
                                                                            <option value={3}>3%</option>
                                                                            <option value={5}>5%</option>
                                                                            <option value={12}>12%</option>
                                                                            <option value={18}>18%</option>
                                                                            <option value={28}>28%</option>
                                                                          </select>
                                        
                                                                        </td>
                    
                                                    <td><input type="text" 
                                                    className="form-control" 
                                                    value={fi.amount || ""} readOnly  disabled={isEditMode && isLocked}/></td>
                                                    <td>
                                                      <button className="btn btn-danger" type='button' onClick={() => handleDeleteItem(idx)} disabled={isEditMode && isLocked}>Delete</button>
                                                    </td>
                                                  </tr>
                                                ))
                                              )}
                                            </tbody>
                                            <tfoot>
                                        
                                                                    <tr>
                                        
                                                                    </tr>
                                        
                                                                    <tr>
                                                                      <td colSpan="5" className="text-end fw-bold">
                                                                        Total Item Amount
                                                                      </td>
                                                                      <td>
                                                                        <input
                                                                          className="form-control"
                                                                          value={subTotal}
                                                                          readOnly
                                                                        />
                                                                      </td>
                                                                    </tr>
                                        
                                        
                                                                    <tr>
                                                                      <td colSpan="4" className="text-end fw-bold">
                                                                        Bill Discount
                                                                      </td>
                                        
                                                                      <td>
                                                                        <select
                                                                          className="form-select"
                                                                          value={billDiscountType || "percent"}
                                                                          onChange={(e) => {
                                        
                                                                            const type = e.target.value;
                                        
                                                                            setBillDiscountType(type);
                                        
                                                                            recalcTotals(
                                                                              formData,
                                                                              formItems?.additionalDetails || [],
                                                                              billDiscountValue || 0,
                                                                              type
                                                                            );
                                        
                                                                          }}
                                                                          disabled={isEditMode && isLocked}
                                                                        >
                                                                          <option value="percent">%</option>
                                                                          <option value="amount">Amount</option>
                                                                        </select>
                                                                      </td>
                                        
                                        
                                                                      <td>
                                                                        <input
                                                                          type="number"
                                                                          className="form-control"
                                                                          value={billDiscountValue ?? ""}
                                                                          onChange={(e) => {
                                        
                                                                            const value = e.target.value;
                                        
                                                                            setBillDiscountValue(value);
                                        
                                                                            recalcTotals(
                                                                              formData,
                                                                              formItems?.additionalDetails || [],
                                                                              value || 0,
                                                                              billDiscountType || "percent"
                                                                            );
                                        
                                                                          }}
                                                                          disabled={isEditMode && isLocked}
                                                                        />
                                                                      </td>
                                                                    </tr>
                                        
                                                                    <tr>
                                                                      <td colSpan="5" className="text-end fw-bold">
                                                                        Taxable Amount
                                                                      </td>
                                                                      <td>
                                                                        <input
                                                                          className="form-control"
                                                                          value={payableAmount}
                                                                          readOnly
                                                                        />
                                                                      </td>
                                                                    </tr>
                                        
                                    
                                        
                                                                    <tr className="text-end fw-bold">
                                                                      <td colSpan="6">
                                                                        <div className="d-flex justify-content-end mb-2">
                                                                          <button
                                                                            type="button"
                                                                            className="btn btn-primary btn-sm"
                                                                            onClick={addRow}
                                                                            disabled={isEditMode && isLocked}
                                                                          >
                                                                            + Add Row
                                                                          </button>
                                                                        </div>
                                                                      </td>
                                                                    </tr>
                                        
                                                                    {formItems.additionalDetails?.map((row, index) => (
                                                                      <tr key={row.id || index}>
                                                                        <td colSpan="7">
                                                                          <div className="d-flex justify-content-end align-items-center gap-2">
                                                                            <Select
                                                                              options={chargeOptions}
                                                                              value={chargeOptions.find(option => option.value === row.type)}
                                                                              onChange={(selected) => {
                                        
                                                                                const selectedCharge = chargeMaster.find(
                                                                                  (item) => item.charge_name === selected.value
                                                                                );
                                                                                updateRowField(row.id, "type", selected.value);
                                                                                if (selectedCharge) {
                                                                                  updateRowField(row.id, "value1", selectedCharge.charge_mrp);
                                                                                }
                                                                              }}
                                                                              placeholder="Select Charge"
                                                                              hideSelectedOptions={false}
                                                                              menuPortalTarget={document.body}
                                                                              styles={{
                                                                                container: base => ({ ...base, width: 150 }),
                                                                                menuPortal: base => ({ ...base, zIndex: 9999 })
                                                                              }}
                                                                              isDisabled={isEditMode && isLocked}
                                                                            />
                                                                            <select
                                                                              className="form-select w-auto"
                                                                              style={{ minWidth: "120px" }}
                                        
                                                                              value={row.chargeType || "amount"}
                                                                              onChange={(e) =>
                                                                                updateRowField(
                                                                                  row.id,
                                                                                  "chargeType",
                                                                                  e.target.value
                                                                                )
                                                                              }
                                                                            >
                                                                              <option value="amount">
                                                                                Amount
                                                                              </option>
                                        
                                                                              <option value="percent">
                                                                                %
                                                                              </option>
                                        
                                                                            </select>
                                        
                                        
                                        
                                                                            <input
                                                                              type="text"
                                                                              className="form-control"
                                                                              style={{ width: "120px" }}
                                                                              value={row.value2 || ""}
                                        
                                                                              onChange={(e) => updateRowField(row.id, "value2", e.target.value)}
                                                                              disabled={isEditMode && isLocked}
                                                                            />
                                        
                                        
                                                                            <select
                                                                              className="form-select w-auto"
                                                                              style={{ minWidth: "90px" }}
                                                                              value={row.gst || 0}
                                                                              onChange={(e) =>
                                                                                updateRowField(row.id, "gst", Number(e.target.value))
                                                                              }
                                                                              disabled={isEditMode && isLocked}
                                                                            >
                                                                              <option value={0}>0%</option>
                                                                              <option value={0.25}>0.25%</option>
                                                                              <option value={3}>3%</option>
                                                                              <option value={5}>5%</option>
                                                                              <option value={12}>12%</option>
                                                                              <option value={18}>18%</option>
                                                                              <option value={28}>28%</option>
                                                                            </select>
                                        
                                        
                                                                            <button className="btn btn-danger btn-sm" onClick={() => deleteRow(index)} disabled={isEditMode && isLocked}>
                                        
                                                                              <MdDeleteForever size={20} />
                                                                            </button>
                                                                          </div>
                                                                        </td>
                                                                      </tr>
                                        
                                                                    ))}
                                        
                                        
                                                                    <tr>
                                                                      <td colSpan="5" className="text-end fw-bold">
                                                                        Total GST
                                                                      </td>
                                                                      <td>
                                                                        <input value={totalTax} readOnly className="form-control" />
                                                                      </td>
                                        
                                                                    </tr>
                                        
                                                                    <tr>
                                                                      <td colSpan="5" className="text-end fw-bold">
                                                                        Grand Total
                                                                      </td>
                                                                      <td>
                                                                        <input
                                                                          className="form-control"
                                                                          value={grandTotal}
                                                                          readOnly
                                                                        />
                                                                      </td>
                                                                    </tr>
                                        
                                                                  </tfoot>
                                          </table>
                                        </div>
                  </div>


                  <div className='col-12 col-md-6 p-3'>
                    <label className='form-label fw-medium'>Attachment</label>
                    <input type="file" className="form-control" name='file' accept="image/*,application/pdf" onChange={handleFileChange}  disabled={isEditMode && isLocked} />
                    {isEditMode && files.file && typeof files.file === "string" && (
                      <div className="mt-2">
                        <span>Previous file: </span>
                        <a href={`https://api.skyguard.group/uploads/${files.file}`} target="_blank" rel="noopener noreferrer">{files.file}</a>
                      </div>
                    )}
                  </div>



                  <div className='col-12 col-md-6 p-3'>
                    <label className='form-label fw-medium'>Description</label>
                    <textarea className='form-control w-100' rows="5" name='description' value={formItems.description} onChange={handleChange}  disabled={isEditMode && isLocked}></textarea>
                  </div>

                  <div className='col-12 col-md-6 p-3'>
                    <label className='form-label fw-medium'>Remark</label>
                    <textarea className='form-control w-100' rows="5" name='remark' value={formItems.remark} onChange={handleChange}  disabled={isEditMode && isLocked}></textarea>
                  </div>

                  <div className='col-12 d-flex justify-content-center gap-2 mt-4'>
                    <button type="submit" className='btn btn-success'  disabled={isEditMode && isLocked}>{isEditMode ? "Update" : "Save"}</button>
                    <button type='button' className='btn btn-danger' onClick={() => { setShowForm(false); setIsEditMode(false); resetForm(); }}>Cancel</button>
                  </div>
                </div>
              </div>


            </form>
             </fieldset>

           
          )}


          <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
            <table className='table table-bordered table-striped table-hover text-center align-middle'>
              <thead className='table-info'>
                <tr>
                  <th scope='col'>SN</th>
                  <th scope='col'>Doc No.</th>
                      <th scope='col' >Action</th>
                  {/* <th scope='col' > Doc No. </th> */}
                  <th scope='col'>Party Name</th>

                  <th scope='col'>Added By</th>
                  <th scope='col'>Added Date</th>

                  <th scope='col'>Edit By</th>

                  <th scope='col'>Edit Date</th>
              
                </tr>
              </thead>
              <tbody>
                {filterReturn.map((p, i) => (
                  <tr key={p.id}>
                    <td>{filterReturn.length - i }</td>
                    <td>{`SR/${p.inv_no}/${branchDetail.code}/${fy.financial_year.split('-')[0]}`}</td>
                    
                    <td>

                      <button
                        className="btn btn-success"

                        onClick={() => handleEdit(p)}
                      >
                        <CiEdit size={20} />
                      </button>



                      <button
                        className="btn btn-secondary mx-1"
                        onClick={() => {
                          setSelectedQuotation(p);
                          setShowDownloadModal(true);
                        }}

                      >
                        <FaDownload size={20} />
                      </button>
                    </td>

                    <td>{p.party_name}</td>
                    <td>{p.added_name} {p.added_name_middle || ""} {p.added_name_last} </td>
                    <td>{formatDateTime(p.created_at)}  </td>

                    <td>{p.edit_name} {p.edit_name_middle || ""} {p.edit_name_last} </td>
                    <td>{formatDateTime(p.edit_date)}</td>


                  </tr>
                ))}
              </tbody>



              {showLetterModal && selectedQuotation && (
                <>
                  <div className="modal-backdrop fade show" onClick={() => setShowLetterModal(false)}></div>
                  <div className="modal d-block" tabIndex="-1">
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                      <div className="print-letter">
                        <div className="modal-content">

                          <div className="modal-header position-relative flex-column align-items-center " style={{ justifyContent: 'center', margin: '15px' }}>

                            <h3 className="text-primary mb-1" style={{ textDecoration: 'underline', marginLeft: '155px' }}>
                              STAR SIGNATURE SERVICES
                            </h3>

                            <p className="text-secondary mb-0" style={{ fontStyle: 'italic' }}>
                              Your satisfaction is our success
                            </p>


                          </div>


                          <div className="modal-body">
                            {/* Subject */}
                            <p style={{ textAlign: "justify" }}>
                              {selectedQuotation.subject && (
                                <p><b>Subject:</b> {selectedQuotation.subject}</p>
                              )}
                            </p>



                            {/* Render rich text safely */}
                            <div
                              style={{ textAlign: "justify", margin: "5px 0", fontSize: "17px", lineHeight: "1", }}
                              dangerouslySetInnerHTML={{ __html: selectedQuotation.customLetter }}
                            />

                            <p>Thank you for considering our services. We look forward to working with you.</p>
                          </div>

                          <div className="modal-footer print-hide">


                            <button
                              type="button"
                              className="btn btn-sm btn-secondary "
                              onClick={() => setShowLetterModal(false)}
                            >
                              Close
                            </button>



                            <button
                              type="button"
                              className="btn btn-primary btn-sm"
                              onClick={() => {
                                const modalContent = document.querySelector('.print-letter');
                                if (modalContent) {
                                  const printWindow = window.open('', '', 'width=1000,height=600');

                                  printWindow.document.write(`
                 <html>
                   <head>
                     <title>Print Quotation</title>
                     <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css">
                     <style>
                       body { font-family: Arial, sans-serif; margin: 20px; }
                       .modal-content { display: block; }
                       .modal-body { white-space: pre-wrap; line-height: 1.5; font-size: 16px; }
                       button { display: none; } /* hide buttons */
                     </style>
                   </head>
                   <body>
                     ${modalContent.innerHTML}
                   </body>
                 </html>
               `);
                                  printWindow.document.close();
                                  printWindow.focus();
                                  printWindow.print();
                                  printWindow.close();
                                }
                              }}
                            >
                              Print
                            </button>


                          </div>

                          {/* Footer Buttons */}
                          <div className="d-flex justify-content-end gap-2 mt-4 ">



                          </div>


                        </div>
                      </div>

                    </div>
                  </div>
                </>
              )}


      {showDownloadModal && selectedQuotation && (() => {
              const parsedItems = selectedQuotation.items
                ? JSON.parse(selectedQuotation.items)
                : [];

              const parsedAdditionalDetails = selectedQuotation.additional_charges
                ? JSON.parse(selectedQuotation.additional_charges)
                : [];


              const headerImageUrl = `https://api.skyguard.group/uploads/${branchDetail.header_img}`;

              return (
                <div
                  className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                  style={{
                    backgroundColor: "rgba(0,0,0,0.5)",
                    zIndex: 9999,
                  }}
                >

                  <div
                    style={{
                      background: "#fff",
                      width: "90%",
                      maxWidth: "900px",
                      borderRadius: "8px",
                      padding: "20px",
                      maxHeight: "90vh",
                      overflowY: "auto",
                      position: "relative",
                    }}
                  >

                    <button
                      onClick={() => setShowDownloadModal(false)}
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        border: "none",
                        background: "transparent",
                        fontSize: "20px",
                        cursor: "pointer",
                      }}
                    >
                      ✖
                    </button>


         

                    <div id="invoice-print-area" style={{ position: "relative" }}>
                      <img
                        src={headerImageUrl}
                        alt="header"
                         style={{
                                                position: "absolute",
                                                top: "30%",
                                                left: "50%",
                                                width: "350px",
                                                height: "350px",
                                                opacity: "0.2",
                                                transform: "translate(-50%, -50%)",
                                                zIndex: "0",
                                            }}
                      />
                      <div style={{ position: "relative", zIndex: 1 }}>

                  

                      <h3 style={{ textAlign: "center", marginBottom: "5px" }}>Sale Invoice</h3>




                      <table style={{ width: "100%", borderCollapse: "collapse" }} border="1">
                        <tbody >
                          <tr >
                            <td style={{ width: "60%", padding: "8px" }} className='text-start'>

                              <table style={{ width: "100%" }} >
                                <tbody>
                                  <tr>{company.name} </tr>
                                  <tr> {company.address} </tr>
                                  <tr>Phone: {company.phone} </tr>
                                  <tr> GSTIN: {company.gst} </tr>
                                  <tr>Email : {company.email} </tr>
                                  <tr>Pan : {company.pan} </tr>
                                </tbody>
                              </table>


                            </td>

                            <td style={{ width: "40%" }} >

                              <table style={{ width: "95%" }} className='text-start'>

                                <tbody >
               
                                  <tr>
                                    <td>Date</td>
                                    <td>{selectedQuotation.quotation_date}</td>
                                  </tr>
                                  <tr>
                                    <td>Shipping Address
                                    </td>
                                    <td>{selectedQuotation.delivery}</td>
                                  </tr>


                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>


                      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }} border="1">
                        <tbody>
                          <tr>
                            <td style={{ width: "50%", padding: "8px" }} className='text-start'>
                              <b>Party Detail:</b><br />
                              <table style={{ width: "100%" }} >
                                <tbody >
                                  <tr>{selectedQuotation.party_name} </tr>
                                  <tr> {selectedQuotation.party_address} </tr>

                                  <tr>{selectedQuotation.party_state} , {selectedQuotation.party_city} </tr>
                                  <tr> {selectedQuotation.party_region}, {selectedQuotation.party_pincode}  </tr>
                                  <tr>Phone: {selectedQuotation.party_phone} </tr>
                                  <tr>  Email: {selectedQuotation.party_email}</tr>
                                  <tr>  CIN No. :{selectedQuotation.party_cin}  </tr>
                                  <tr>  MSME :{selectedQuotation.party_msme} </tr>

                                </tbody>
                              </table>
                            </td>

                          </tr>
                        </tbody>
                      </table>


                      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }} border="1" className='table table-bordered table-striped table-hover text-center align-middle'>
                        <thead>
                          <tr>
                            <th>Sr No</th>
                            <th>Description of Goods</th>
                            {/* <th>HSN</th> */}
                            <th>Qty</th>
                     
        <th>Rate</th>
     
        <th>Amount</th> 
                          </tr>
                        </thead>

                        <tbody>
                          {parsedItems.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.name}</td>

                              <td>{item.qty}</td>
                          
          <td>{item.rate}</td>
       
          <td>{item.amount}</td> 
                            </tr>
                          ))}


       

      {/* ✅ ADDITIONAL CHARGES */}
{parsedAdditionalDetails.length > 0 && (
  <>
    <tr>
      <td colSpan="5" style={{ textAlign: "left", fontWeight: "bold" }}>
        Additional Charges
      </td>
    </tr>

    {parsedAdditionalDetails.map((row, index) => (
      <tr key={index}>
        <td colSpan="4" style={{ textAlign: "right" }}>
          {row.type}
        </td>
        <td style={{ textAlign: "right" }}>
          {Number(row.value2 || 0).toFixed(2)}
        </td>
      </tr>
    ))}
  </>
)}

      <tr>
        <td colSpan="4" style={{ textAlign: "right" }}><b>Total</b></td>
        <td><b>{selectedQuotation.grand_total}</b></td>
      </tr>
                        </tbody>
                      </table>


                      <div style={{ marginTop: "5px", border: "1px solid #000", padding: "5px" }} className='text-start'>
                        <b>Amount Chargeable (In Words):</b> Rupees Only
                      </div>


                      <table
                        style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }}
                        border="1"
                      >
                        <tbody>
                          <tr>

                            {/* 1️⃣ SUPPLIER BOX */}
                            <td style={{ width: "50%", padding: "8px", verticalAlign: "top" }}>

                              <div style={{ border: "1px solid #000", padding: "8px" }}>
                                <b>Company Bank Details:</b>

                                <table style={{ width: "100%", marginTop: "5px" }} className='table table-bordered table-striped table-hover text-center align-middle'>
                                  <tbody>
                                    <tr>
                                      <td>Bank Name</td>
                                      <td>{company.bank_name} </td>
                                    </tr>
                                    <tr>
                                      <td>Account No</td>
                                      <td>{company.acc_no}  </td>
                                    </tr>
                                    <tr>
                                      <td>IFSC Code</td>
                                      <td>{company.ifsc} </td>
                                    </tr>
                                    <tr>
                                      <td>Branch</td>
                                      <td>{company.branch} </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>

                            </td>

                            {/* 2️⃣ BUYER BOX */}
                            <td style={{ width: "50%", padding: "8px", verticalAlign: "top" }}>

                              <div style={{ border: "1px solid #000", padding: "8px" }}>
                                <b>Party Bank Details:</b>

                                <table style={{ width: "100%", marginTop: "5px" }} className='table table-bordered table-striped table-hover text-center align-middle'>
                                  <tbody>
                                    <tr>
                                      <td>Bank Name</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <td>Account No</td>
                                      <td> - </td>
                                    </tr>
                                    <tr>
                                      <td>IFSC Code</td>
                                      <td>- </td>
                                    </tr>
                                    <tr>
                                      <td>Branch</td>
                                      <td>- </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>

                            </td>

                          </tr>
                        </tbody>
                      </table>


                     

                      <table style={{ width: "100%", borderCollapse: "collapse" }}>
  <tbody>
    <tr> 
      <td
        style={{
          width: "100%",  
          padding: "8px",
          verticalAlign: "top",
          textAlign: "right", 
        }}
      >
        <div
          style={{
            border: "1px solid #000",
            height: "160px",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
            padding: "10px",
          }}
        >
          <b>Authorised Signatory</b>
        </div>
      </td>
    </tr>
  </tbody>
</table>



                      <table className="table table-start">
                        <tbody>
                          <tr>
                            <td
                              style={{
                                width: "34%",
                                padding: "8px",
                                verticalAlign: "top", 
                                textAlign: "left",    
                              }}
                            >
                              <div
                                style={{
                                  border: "1px solid #000",
                                  height: "160px",
                                  paddingBottom: "10px",
                                  textAlign: "left", // ✅ ensure inner content also left
                                }}
                              >
                                <strong>T & C :</strong>

                                {selectedQuotation.remark
                                  ?.split(/(?=\d+\.)/)
                                  .map((item, index) => (
                                    <div key={index} style={{ textAlign: "left" }}>
                                      {item.trim()}
                                    </div>
                                  ))}
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>


                      <div style={{ textAlign: "center", marginTop: "5px", fontSize: "12px" }}>
                        SUBJECT TO MUMBAI JURISDICTION  We are registered under MSME Act2006, Our MSME no is 'UDYAM-MH-18-0006676
                      </div>

                    </div>


                    <div
                      className="no-print"
                      style={{ marginTop: "15px", textAlign: "right" }}
                    >
                      <button
                        onClick={handlePrint}
                        style={{
                          marginRight: "10px",
                          padding: "8px 15px",
                          background: "#007bff",
                          color: "#fff",
                          border: "none",
                          borderRadius: "4px",
                        }}
                      >
                        Print
                      </button>

                      <button
                        onClick={() => setShowDownloadModal(false)}
                        style={{
                          padding: "8px 15px",
                          background: "red",
                          color: "#fff",
                          border: "none",
                          borderRadius: "4px",
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>

                      </div>

                  {/* PRINT CSS */}
                  <style>
                    {`
          @media print {
            .no-print {
              display: none !important;
            }
          }
        `}
                  </style>
                </div>
              );
            })()}


            </table>
          
             {hasMore && (
                            <div className="text-center mt-3">
                                <button
                                    className="btn btn-primary"
                                    onClick={handleLoadMore}
                                >
                                    Load More
                                </button>
                            </div>
                        )}
          </div>
        </div>
      </div>
    </>
  )
}

export default SaleReturn


// Export to Excel
export const exportInvoiceToExcel = (selectedQuotation) => {
  const items = selectedQuotation.items ? JSON.parse(selectedQuotation.items) : [];
  const data = items.map((item) => ({
    "Item Name": item.name,
    Qty: item.qty,
    Rate: item.rate,
    "GST %": item.tax,
    Amount: item.amount,
  }));

  // Add totals at bottom
  data.push({});
  data.push({ "Item Name": "Total GST", Amount: selectedQuotation.total_gst });
  data.push({ "Item Name": "Sub Total", Amount: selectedQuotation.sub_total });
  data.push({ "Item Name": "Grand Total", Amount: selectedQuotation.grand_total });

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Invoice");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, `Invoice_${selectedQuotation.invoice_no || "NA"}.xlsx`);
};
